module.exports = __webpack_public_path__ + "img/44Obama.6df8e71c.png";